import util from "../utils/util";

export default class UserService {
  login(email, password) {
    let body = { email, password, isAdmin: true };
    return util
      .sendApiRequest("/user/login", "POST", true, body)
      .then((response) => {
        localStorage.setItem("user", JSON.stringify(response));
        localStorage.setItem("lastActivityTime", Date.now().toString());
        window.user = response;
        return window.user;
      })
      .catch((e) => {
        throw e;
      });
  }

  logout() {
    localStorage.removeItem("user");
    localStorage.removeItem("lastActivityTime");
    window.user = null;
  }

  logoutSession() {
    return util.sendApiRequest("/user/logout", "POST", true, {}).then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  }

  getUser(id, withCourse) {
    return util
      .sendApiRequest("/user/" + id + (withCourse ? "/1" : ""), "GET", true)
      .then(
        (response) => {
          return response;
        },
        (error) => {
          throw new Error(error);
        }
      );
  }

  listUser(data, start, perpage) {
    const user = Object.keys(data).reduce((object, key) => {
      if (data[key] !== "") {
        object[key] = data[key];
      }
      return object;
    }, {});
    return util
      .sendApiRequest("/user/list/" + start + "/" + perpage, "POST", true, user)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        throw err;
      });
  }
  deleteUser(_id) {
    return util.sendApiRequest("/user/" + _id, "DELETE", true).then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  }

  logoutAllSession() {
    return util
      .sendApiRequest("/user/logout-all-session", "POST", true, {})
      .then(
        (response) => {
          return response;
        },
        (error) => {
          throw error;
        }
      );
  }
}
